import { DateTime } from 'luxon';

export function toRelative(date: DateTime | string) {
  const dateTime = typeof date === 'string' ? DateTime.fromISO(date) : date;
  if (dateTime.diffNow().as('seconds') > -30) {
    return 'just now';
  }
  return dateTime.toRelative();
}
